import React, { useEffect } from 'react';

const WebsiteSchema: React.FC = () => {
  useEffect(() => {
    // Create the schema
    const schema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "festutrustning.se",
      "url": "https://festutrustning.se",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://festutrustning.se/produkter?search={search_term_string}",
        "query-input": "required name=search_term_string"
      },
      "description": "Hyr professionell festutrustning i Skåne. Ljud, ljus och DJ-utrustning för alla tillfällen. Leverans inom 10 mil från Malmö.",
      "publisher": {
        "@type": "Organization",
        "name": "festutrustning.se",
        "logo": {
          "@type": "ImageObject",
          "url": "https://festutrustning.se/logo.png"
        }
      }
    };

    // Add the schema to the page
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    // Clean up
    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(s => {
        try {
          const data = JSON.parse(s.textContent || '{}');
          if (data['@type'] === 'WebSite') {
            s.remove();
          }
        } catch (e) {
          // Ignore parsing errors
        }
      });
    };
  }, []);

  return null;
};

export default WebsiteSchema;